module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_9016.b718d6c5.png";